export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fBBc4.woff2";